import type { ReceiptTemplate } from '../schema';

export const gcashTemplate: ReceiptTemplate = {
  id: 'gcash',
  name: 'GCash Receipt',
  brand: 'GCASH',
  description: 'GCash payment receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'gc-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: 'GCASH',
        businessNameFontSize: 22,
        addressLines: ['PAYMENT RECEIPT'],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'gc-trans',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'ref', label: 'Ref #:', value: 'GC-847291034' },
          { id: 'to', label: 'To:', value: 'MIKE WAZOWSKI' },
        ],
        column2: [
          { id: 'date', label: 'Date:', value: '01/04/2026' },
          { id: 'time', label: 'Time:', value: '2:45 PM' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'gc-amount',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'amount', label: 'AMOUNT', value: '1500.00', isBold: true, isLarge: true },
          { id: 'fee', label: 'SERVICE FEE', value: '0.00', isBold: false, isLarge: false },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'gc-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'TRANSACTION SUCCESSFUL\n\nTHANK YOU FOR USING GCASH',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
  updatedAt: new Date().toISOString(),
};
